<template>
  <div class="editor">
    <div class="editor__header">
      <div class="editor__header--left">
        <h2 class="large-title">Campaign Editor</h2>
        <p>Set your campaign details</p>
      </div>
      <div class="editor__header--right">
        <!-- <button class="btn-large secondary" @click="duplicateCampaign">Duplicate campaign</button> -->
        <button :ref="'duplicate'" class="loading" @click="duplicateCampaign">
          <span> Duplicate campaign </span>
          <adx-loading-secondary v-if="isLoadDuplicate" slot="loading" />
        </button>
      </div>
    </div>
    <div v-if="isLoadInfo" class="editor__loading">
      <adx-loading slot="loading" />
    </div>
    <div v-else class="editor__content">
      <div class="editor__content--left">
        <div class="editor__content__info">
          <span class="strong">Information</span>
          <div class="editor__content__info__fields">
            <adx-input :label="`Campaign Name`" :value.sync="campaignName" :error="inputError" :validationMethod="'onChange'"/>
            <adx-select-dropdown :label="`Ads Duration`" :value.sync="campaignDuration" :options="dropdown" />
          </div>
        </div>
        <div class="editor__content__channels">
          <span class="strong">Channels</span>
          <div v-for="(item, index) in channels" :key="index" class="editor__content__channels__group"
          :class="{error : error[item.category]}">
            <div class="editor__content__channels__group__info">
              <div v-if="item.category == 'idooh'" class="editor__content__channels__group__info__title">
                <div class="header">
                  <span class="title"> Digital Screen </span>
                  <span class="count"> {{item.items}} Items </span>
                </div>
                <tooltip text="You can schedule your campaign for days of the week." :isLong="true">
                  <span slot="content">
                    <div class="editor__content__channels__group__info__title__tooltip">
                      <img src="/img/icons/ic-info@2x.png" alt="">
                      <!-- <div @mouseover="tooltipToggle('active')" @mouseleave="tooltipToggle('inactive')" class="icon-tooltip" :style="{backgroundImage: 'url(' + tooltipImg + ')'}"></div> -->
                    </div>
                  </span>
                </tooltip>
              </div>
              <div v-else class="editor__content__channels__group__info__title">
                {{item.category.charAt(0).toUpperCase() + item.category.substr(1)}}
                <span class="count">
                  {{item.item_count}} Items
                  <tooltip text="The number of all listing in your campaign." :isLong="true">
                    <span slot="content">
                      <div class="editor__content__channels__group__info__title__tooltip">
                        <img src="/img/icons/ic-info@2x.png" alt="">
                        <!-- <div @mouseover="tooltipToggle('active')" @mouseleave="tooltipToggle('inactive')" class="icon-tooltip" :style="{backgroundImage: 'url(' + tooltipImg + ')'}"></div> -->
                      </div>
                    </span>
                  </tooltip>
                </span>
              </div>
              <div class="editor__content__channels__group__info__price">
                <div class="editor__content__channels__group__info__price--column align-right">
                  Price
                  <div class="price-channel">
                    <div v-if="isLoadEstimatePrice[item.category]"  class="price-channel__load">
                      <adx-loading-secondary slot="loading" />
                    </div>
                    <span v-else class="align-right">{{item.total_price | formatMoney}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.category !== 'videotron'" class="editor__content__channels__group__body">
              <div :class="['calendar', (item.start <= today && !isNew) ? 'warning' : '']">
                <label class="small-font">Campaign start</label>
                <v-date-picker
                  v-model='item.start'
                  :min-date='tomorrow'
                  :max-date='item.end'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  @input="setPeriod(item.category, item.start, item.end)"
                  class='date-input'>
                  <input
                    class="calendar-start"
                    placeholder= "DD/MM/YYYY"
                    type='text'
                    slot-scope='{ inputValue, updateValue }'
                    :value='inputValue'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
              </div>
              <div :class="['calendar', (item.end <= today && !isNew) ? 'warning' : '']">
                <label class="small-font">Campaign end</label>
                <v-date-picker
                  v-model='item.end'
                  :min-date='item.start > tomorrow ? item.start : tomorrow'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  @input="setPeriod(item.category, item.start, item.end)"
                  class='date-input'>
                  <input
                    class="calendar-start"
                    placeholder= "DD/MM/YYYY"
                    type='text'
                    slot-scope='{ inputValue, updateValue }'
                    :value='inputValue'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
              </div>
            </div>
            <div v-else class="editor__content__channels__group__body">
              <adx-select-dropdown :label="`Period of campaign`" :value.sync="monthPeriod"
              :options="periods" />
              <div class="calendar">
                <label class="small-font">Campaign Date</label>
                <v-date-picker
                  v-model='startDate[item.category]'
                  class='date-input'
                  :theme-styles='themeStyles'
                  :popoverVisibility="'focus'">
                  <input
                    class="calendar-start"
                    type='text'
                    slot-scope='{ inputValue, updateValue }'
                    disabled
                    :value='formatDate(inputValue)'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @popover-did-appear='toggleBorder'
                    @popover-did-disappear='toggleBorder'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
                <i class="icon-chevronright"></i>
                <v-date-picker
                  v-model='endDate[item.category]'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-input'>
                  <input
                    class="calendar-end"
                    type='text'
                    slot-scope='{ inputValue, updateValue }'
                    disabled
                    :value='formatDate(inputValue)'
                    @popover-did-appear='toggleBorder'
                    @popover-did-disappear='toggleBorder'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
              </div>
            </div>
            <div v-if="error[item.category]" class="editor__content__channels__group__error">
              <span>Oops! Minimum Ads duration for this channels is 30 Seconds. you can change your ads duration or remove this channel from campaign.</span>
              <button class="btn-regular secondary">Remove channel</button>
            </div>
            <div v-if="((item.start <= today || item.end <= today) && !isNew)" class="editor__content__channels__group__warning">
              <span>Your campaign date is expired. Please set new date.</span>
            </div>
          </div>
        </div>
        <div class="editor__content__media">
          <span class="strong">Media</span>
          <div class="editor__content__media__items">
            <div v-if="requireContent['landscape']" :class="['editor__content__media__items__landscape', (selectedLandscape == null && !isNew) ? 'warning' : '']" @click.stop="chooseMedia('landscape')">
              <div class="editor__content__media__items__landscape__content_wrapper">
                <div v-if="selectedLandscape && selectedLandscape.type.toLowerCase() == 'video'" class="editor__content__media__items__overlay">
                  <img src="/img/icons/ic_play2.svg" alt="">
                </div>
                <img v-if="!selectedLandscape" class="empty" :src="`/img/notfound/img-placeholder-landscape@2x.png`" alt="">
                <img v-else :src="selectedLandscape.thumb" alt="">
              </div>
              <div class="info">
                <span class="strong">Landscape Media</span>
                <p class="desktop">Size recomended 1920 x 1080 px</p>
                <div class="mobile">
                  <p>Size recomended</p>
                  <p>1920 x 1080 px</p>
                </div>
              </div>
            </div>
            <div v-if="requireContent['portrait']" :class="['editor__content__media__items__portrait', (selectedPortrait == null && !isNew) ? 'warning' : '']" @click.stop="chooseMedia('portrait')">
              <div class="editor__content__media__items__landscape__content_wrapper">
                <div v-if="selectedPortrait && selectedPortrait.type.toLowerCase() == 'video'" class="editor__content__media__items__overlay">
                  <img src="/img/icons/ic_play2.svg" alt="">
                </div>
                <img v-if="!selectedPortrait" :src="`/img/notfound/img-placeholder-portrait@2x.png`" alt="">
                <img v-else :src="selectedPortrait.thumb" alt="">
              </div>
              <div class="info">
                <span class="strong">Portrait Media</span>
                <p class="desktop">Size recomended 1080 x 1920 px</p>
                <div class="mobile">
                  <p>Size recomended</p>
                  <p>1080 x 1920 px</p>
                </div>
              </div>
            </div>
            <div v-if="requireContent['square']" :class="['editor__content__media__items__square', (selectedSquare == null && !isNew) ? 'warning' : '']" @click.stop="chooseMedia('square')">
              <div class="editor__content__media__items__landscape__content_wrapper">
                <div v-if="selectedSquare && selectedSquare.type.toLowerCase() == 'video'"  class="editor__content__media__items__overlay">
                  <img src="/img/icons/ic_play2.svg" alt="">
                </div>
                <!-- <img :src="`/img/notfound/img-placeholder-square@2x.png`" alt=""> -->
                <img v-if="!selectedSquare" :src="`/img/notfound/img-placeholder-square@2x.png`" alt="">
                <img v-else :src="selectedSquare.thumb" alt="">
              </div>
              <div class="info">
                <span class="strong">Square Media</span>
                <p class="desktop">Size recomended 1080 x 1080 px</p>
                <div class="mobile">
                  <p>Size recomended</p>
                  <p>1080 x 1080 px</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(!selectedLandscape && requireContent['landscape'] && !isNew) || (!selectedPortrait && requireContent['portrait'] && !isNew) || (!selectedSquare && requireContent['square'] && !isNew)" class="editor__content__media__items__warning">
            <span>Please select media to your campaign</span>
          </div>
        </div>
      </div>
      <div class="editor__content--right">
        <div :class="['editor__content__total-listing', totalListings == 0 ? 'warning' : '']">
          <div class="editor__content__total-listing__info">
            <div class="left">
              <span class="strong">Total Listing </span>
              <tooltip text="The number of all listing in your campaign.">
                <span slot="content">
                  <div class="editor__content__channels__group__info__title__tooltip">
                    <img src="/img/icons/ic-info@2x.png" alt="">
                    <!-- <div @mouseover="tooltipToggle('active')" @mouseleave="tooltipToggle('inactive')" class="icon-tooltip" :style="{backgroundImage: 'url(' + tooltipImg + ')'}"></div> -->
                  </div>
                </span>
              </tooltip>
            </div>
            <span class="total">{{totalListings | formatNumber}} items</span>
          </div>
          <div class="editor__content__total-listing__view">
            <button class="btn-regular secondary" @click="openListings"> Edit </button>
          </div>
          <div class="editor__content__total-listing__warning" v-if="totalListings == 0">
            <span>Listing can't be empty. Please select a listing</span>
          </div>
        </div>
        <div class="editor__content__estimated">
          <div class="editor__content__estimated__info">
            <div class="header">
              <span class="strong">Estimated Views</span>
              <tooltip text=" The number of people who saw your ads at least once.">
                <span slot="content">
                  <div class="editor__content__channels__group__info__title__tooltip">
                    <img src="/img/icons/ic-info@2x.png" alt="">
                    <!-- <div @mouseover="tooltipToggle('active')" @mouseleave="tooltipToggle('inactive')" class="icon-tooltip" :style="{backgroundImage: 'url(' + tooltipImg + ')'}"></div> -->
                  </div>
                </span>
              </tooltip>
            </div>
            <div class="editor__content__estimated__info__content">
              <div class="editor__content__estimated__info__content--left">
                <p>Daily</p>
                <p>Monthly</p>
                <p>Potential Reach</p>
              </div>
              <div class="editor__content__estimated__info__content--right">
                <div v-if="isLoadEstimateViews" class="editor__content__estimated__info__content--right__load">
                  <adx-loading-secondary slot="loading" />
                </div>
                <span v-else>{{estimatedViews.daily | formatNumber}}</span>

                <div v-if="isLoadEstimateViews" class="editor__content__estimated__info__content--right__load">
                  <adx-loading-secondary slot="loading" />
                </div>
                <span v-else>{{estimatedViews.monthly | formatNumber}}</span>

                <div v-if="isLoadEstimateViews" class="editor__content__estimated__info__content--right__load">
                  <adx-loading-secondary slot="loading" />
                </div>
                <span v-else>{{estimatedViews.potential_reach | formatNumber}} people</span>
              </div>
            </div>
          </div>
          <div class="editor__content__estimated__view">
            <!-- <button class="btn-regular secondary"> View Detail</button> -->
          </div>
        </div>
        <div class="editor__content__desktop">
          <div class="editor__content__price">
            <span>Total Price</span>
            <div v-if="isLoadTotalPrice"  class="editor__content__price__load">
              <adx-loading-secondary :width="22" :height="22" slot="loading" />
            </div>
            <span v-else class="editor__content__price__total">{{totalPrice | formatMoney}}</span>
          </div>
          <div class="editor__content__buttons">
            <!-- <button class="btn-large secondary">Saved as draft</button> -->
            <button class="btn-large primary" @click="toDraft">Checkout</button>
          </div>
        </div>
        <div class="editor__content__mobile">
          <div class="editor__content__fixed">
            <div class="editor__content__fixed__price">
              <span class="title">Total Price</span>
              <div v-if="isLoadTotalPrice"  class="editor__content__fixed__price__load">
                <adx-loading-secondary slot="loading" />
              </div>
              <span v-else class="editor__content__fixed__price__total">{{totalPrice | formatMoney}}</span>
            </div>
            <div class="editor__content__fixed__checkout">
              <button class="btn-regular primary" @click="toDraft">Checkout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="isShowListings" @modal-close="closeModal" :type="isMobile ? '' : 'large'" :noTitleTop="true">
      <div class="editor__listings" slot="content">
        <div class="editor__listings__header">
          <h2 class="small-title">{{campaignName}}</h2>
          <p>Total listing {{totalListings}} item</p>
        </div>
        <div v-if="isLoadingListings" class="editor__listings__loading">
          <adx-loading slot="loading" />
        </div>
        <template v-else>
          <div class="editor__listings__actions">
            <button class="btn-regular primary btn-desktop" @click.stop="addmore">Add more</button>
            <div class="editor__listings__actions--right">
              <p>Filter :</p>
              <adx-select-dropdown class="filter" :value.sync="selectedFilter" :type="true" :options="filter"/>
            </div>
            <adx-list-dropdown class="filter-mobile" @selected="selectFilter" :list="filter"
            :labelButton="filterLabel" :title="`Filter by`" />
            <button class="btn-regular primary btn-mobile" @click.stop="addmore">Add more</button>
          </div>
          <div class="editor__listings__search">
            <div class="editor__listings__search__input">
              <i class="adx-ic_search"></i>
              <input type="text" class="subhead" placeholder="Search" v-model="searchBoxValue">
            </div>
          </div>
          <div v-if="searchNotFound" class="editor__listings__search__error">
            <div class="editor__listings__search__error__top">
              <span>What worse, a hilarious no result page can't be found either : </span>
              <span class="search">"{{searchBoxValue}}"</span>
            </div>
            <div class="editor__listings__search__error__bottom">
              <span>Maybe you want to check other listing :</span>
            </div>
          </div>
          <div class="editor__listings__content">
            <div class="editor__listings__content__list" v-for="(category, index) in lists" :key="index">
              <div class="editor__listings__content__list__header">
                <h2 class="small-title">{{category.title | capitalizing}}</h2>
                <button :ref="'delete_' + category.title.toLowerCase()" class="loading"
                @click="removeCategoryListings(category.title.toLowerCase())">
                  <span> Delete {{category.title | capitalizing}} </span>
                  <adx-loading-secondary v-if="isLoadDelete.includes(category.title.toLowerCase())"
                  slot="loading" />
                </button>
              </div>
              <adx-list-item :category="category.title.toLowerCase()" :items='category.items' @reloadData="removeListingsData"/>
            </div>
          </div>
        </template>
      </div>
    </modal>
    <modal
      v-if="mediaModal"
      type="large"
      title="Choose Media File"
      @modal-close="closeMediaModal"
    >
      <div slot="content" class="media_editor">
        <div class="media_editor__menu">
          <span :class="['medialib', modalMediaTab == 'media' ? 'active' : '']" @click.stop="changeMediaTab('media')" class="subhead">Media Library</span>
          <span :class="['localfile', modalMediaTab == 'localfile' ? 'active' : '']" @click.stop="changeMediaTab('localfile')" class="subhead">Upload File</span>
        </div>
        <div class="media_editor__content">
          <adx-media v-if="modalMediaTab == 'media'" :orientation="orientationOnModal" :is-modal="true" @selected="setMedia" />
          <adx-upload v-if="modalMediaTab == 'localfile'" @done="changeMediaTab('media')" :orientation="orientationOnModal" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import ListItems from '@/views/CampaignEditor/ListItems'
import Modal from '@/components/Modal'
import Tooltip from '@/components/Tooltip'
import Loading from '@/components/Loading/Primary'
import LoadingSpinner from '@/components/Loading/Secondary'
import MediaLibrary from '@/views/Media'
import Upload from '@/views/Upload'

import api from '@/api/'
import moment from 'moment';
import calendar from 'v-calendar'
import { formatShortDate } from '@/lib/util'
import * as validationLib from '@/lib/validation/'

const { helpers } = validationLib

export default {
  name: "adx-campaign-editor",
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-list-dropdown': DropdownList,
    'adx-list-item': ListItems,
    'adx-loading': Loading,
    'adx-loading-secondary': LoadingSpinner,
    'adx-media': MediaLibrary,
    'adx-upload': Upload,
    'v-calendar': calendar,
    Modal,
    Tooltip
  },
  props: {
    openModal: {
      required: false
    },
    newCampaign: {
      required: false
    },
  },
  data(){
    return {
      initial: true,
      initialDuration: true,
      isMobile: window.innerWidth < 769,
      isShowListings: false,
      selectedFilter: '-',
      filterLabel: 'Filter',
      campaignDuration: 0,
      allCategory: [],
      inputError: '',
      campaignName: '',
      campaign: {
        title: '',
        duration: 0
      },
      tooltipImg: '/img/icons/ic-info@2x.png',
      monthPeriod: '1',
      isLoadDuplicate: false,
      isLoadTotalPrice: false,
      isLoadInfo: true,
      isLoadDelete: [],
      isLoadEstimatePrice: {},
      isLoadEstimateViews:  true,
      isLoadingListings: true,
      requireContent: {
        'landscape': false,
        'portrait': false,
        'square': false
      },
      listings: [],
      lists: [],
      filter: [],
      periods: [
        {
          label: '1 Month',
          value: '1'
        },
        {
          label: '2 Month',
          value: '2'
        },
        {
          label: '3 Month',
          value: '3'
        },
        {
          label: '4 Month',
          value: '4'
        },
        {
          label: '5 Month',
          value: '5'
        },
        {
          label: '6 Month',
          value: '6'
        },
        {
          label: '7 Month',
          value: '7'
        },
        {
          label: '8 Month',
          value: '8'
        },
        {
          label: '9 Month',
          value: '9'
        },
        {
          label: '10 Month',
          value: '10'
        },
        {
          label: '11 Month',
          value: '11'
        },
        {
          label: '12 Month',
          value: '12'
        },
      ],
      dropdown: [
        {
          label: '15 Seconds',
          value: 15
        },
        {
          label: '30 Seconds',
          value: 30
        },
        {
          label: '45 Seconds',
          value: 45
        },
        {
          label: '60 Seconds',
          value: 60
        },
        {
          label: '75 Seconds',
          value: 75
        },
        {
          label: '90 Seconds',
          value: 90
        },
        {
          label: '105 Seconds',
          value: 105
        },
      ],
      startDate: {},
      endDate: {},
      singleDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      error: {
        'digital': '',
        'videotron': 'Oops! Minimum Ads duration for this channels is 30 Seconds. you can change your ads duration or remove this channel from campaign.'
      },
      channels: [],
      estimatedViews: {
        'daily': 0,
        'monthly': 0,
        'potential_reach': 0
      },
      orientationOnModal: null,
      mediaModal: false,
      selectedLandscape: null,
      selectedPortrait: null,
      selectedSquare: null,
      modalMediaTab: 'media',
      today: moment(),
      searchBoxValue: '',
      searchNotFound: false,
      isNew: false,
    }
  },
  mounted(){
    if (this.newCampaign) {
      this.isNew = true
    }
    this.initialLoad()
    if (this.openModal) {
      this.openListings()
    }
  },
  methods: {
    toDraft() {
      this.$router.push({name: 'draft'})
    },
    formatDate(date) {
      return formatShortDate(date)
    },
    openListings() {
      this.isShowListings = true
      if (this.lists.length == 0) {
        this.loadListings()
      }
    },
    duplicateCampaign() {
      (async () => {
        this.isLoadDuplicate = true
        this.$refs['duplicate'].disabled = true
        const response = await api.post(`v2/campaign/${this.$route.params.id}/duplicate/`,
        {},  { needToken: true })
        this.$refs['duplicate'].disabled = false
        if (response.status == 201) {
          this.$notify({
            group: 'saved',
            title: 'Duplicate campaign success',
            text: this.campaignName + ' has been duplicated to a new campaign',
            type: 'success'
          });
        } else {
          this.$notify({
            group: 'saved',
            title: 'Duplicate campaign failed',
            text: response.data.message,
            type: 'danger',
            duration: 5000
          });
        }
        this.isLoadDuplicate = false
      })();
    },
    estimatePrice(category) {
      let list_category = []
      if (category !== 'all') {
        list_category.push(category)
      } else {
        list_category = this.allCategory
      }

      list_category.forEach((name, index) => {

        if (category !== 'all') {
          this.loadEstimatedViews();
        }

        let params = {
          category: name
        };

        (async () => {
          this.isLoadTotalPrice = true
          this.isLoadEstimatePrice[name] = true
          const { data } = await api.get(`v2/campaign/${this.$route.params.id}/estimated_price/`, { needToken: true, params: params })
          this.channels.map(channel => {
            if (channel.category == name) channel.total_price = data.total
          })
          this.isLoadEstimatePrice[name] = false
          if (index == list_category.length - 1 ) this.isLoadTotalPrice = false
        })();
      });
    },
    selectFilter(item){
      if (this.selectedFilter === item.value) {
        this.selectedFilter = `name`
      } else {
        this.selectedFilter = item.value
      }
    },
    setPeriod(category, start, end) {
      let start_date = start ? moment(start).format('YYYY-MM-DD') : ""
      let end_date = end ? moment(end).format('YYYY-MM-DD') : ""

      let data = {
        channel_name: category,
        start: start_date,
        end: end_date,
      };

      (async () => {
        this.isLoadTotalPrice = true
        this.isLoadEstimatePrice[category] = true
        this.isLoadEstimateViews = true
        const response = await api.put(`v2/campaign/${this.$route.params.id}/channel/period/`,
        data, { needToken: true })
        if (response.status == 200) {
          this.estimatePrice(category)
        } else {
          this.isLoadTotalPrice = false
          this.isLoadEstimatePrice[category] = false
          this.isLoadEstimateViews = false
        }
      })();
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    removeCategoryListings(category) {
      let data = {
          'category_channel': category
      };
      (async () => {
        this.isLoadDelete.push(category)
        this.$refs['delete_' + category][0].disabled = true
        const response = await api.patch(`v2/campaign/${this.$route.params.id}/devices/remove/bulk/`, data, { needToken: true })
        this.$refs['delete_' + category][0].disabled = false
        if (response.status == 200) {
          this.removeListingsData(category)
        }
        let index = this.isLoadDelete.indexOf(category)
        if (index > -1) {
          this.isLoadDelete.splice(index, 1)
        }
      })();
    },
    removeListingsData(category, partial_id=null){
      this.loadInfo()
      this.loadRequireContent()
      if (partial_id) {
        let remove_index = null
        this.listings[category].map((value, index) => {
          if (value.id == partial_id) remove_index = index
        })
        this.listings[category].splice(remove_index, 1);
      } else {
        this.listings[category] = []
      }

      let empty = false
      this.lists.map((obj) => {
        if (this.selectedFilter == obj.title.toLowerCase()) {
          if (obj.items.length == 0) empty = true
        }
      })

      if(empty) {
        this.filter = [{
          id: 0,
          label: "All",
          value: "-"
        }]
        this.selectedFilter = '-'
        this.filterLabel = 'All'
        this.loadFilter()
      }

      if (this.selectedFilter !== '-') {
        this.mappingListings(this.selectedFilter)
      } else {
        this.mappingListings()
      }
    },
    checkContent(old_require, new_require) {
      // let rotation = ['landscape', 'portrait', 'square']
      // rotation.forEach((key) => {
      //   if (old_require[key].length !== 0 && new_require[key].length == 0){
      //     if (key == 'landscape') {
      //       this.selectedLandscape['orientation'] = key
      //       this.setMedia(this.selectedLandscape, true)
      //     } else if (key == 'portrait') {
      //       this.selectedPortrait['orientation'] = key
      //       this.setMedia(this.selectedPortrait, true)
      //     } else {
      //       this.selectedSquare['orientation'] = key
      //       this.setMedia(this.selectedSquare, true)
      //     }
      //   }
      // });
      // this.requireContent = new_require
    },
    initialLoad() {
      this.loadInfo()
      this.loadRequireContent()
      this.loadContents()
    },
    loadEstimatedViews(start=null, end=null, category=null) {
      let list_category = []
      if (category) {
        list_category.push(category)
      } else {
        list_category = this.allCategory
      }

      let estimated = {
        'daily': 0,
        'monthly': 0,
        'potential_reach': 0
      }

      let params = {}
      if (start) params['start'] = start
      if (end) params['end'] = end;

      list_category.forEach((category) => {
        params['category'] = category;

        (async () => {
          this.isLoadEstimateViews = true
          const { data } = await api.get(`v2/campaign/${this.$route.params.id}/estimated_views/`, { needToken: true, params: params })
          // this.estimatedViews = data
          estimated.daily += data.daily
          estimated.monthly += data.monthly
          estimated.potential_reach += data.potential_reach
          this.isLoadEstimateViews = false
        })();
      });

      this.estimatedViews = estimated
    },
    loadContents() {
      (async () => {
        const { data } = await api.get(`v2/campaign/${this.$route.params.id}/contents/`, { needToken: true })
        this.selectedLandscape = data.filter(x => x.rotation === 0).pop()
        this.selectedPortrait = data.filter(x => x.rotation === 90).pop()
      })();
    },
    loadInfo() {
      let params = {};
      (async () => {
        this.isLoadInfo = true
        const { data } = await api.get(`v2/campaign/${this.$route.params.id}/info/`, { needToken: true, params: params })
        this.campaign.title = data.title
        this.campaignName = data.title
        this.campaignDuration = data.duration
        this.campaign.duration = data.duration
        this.channels = data.channels
        this.mappingCategory()
        this.mappingDate()
        this.loadEstimatedViews()
        this.isLoadInfo = false
      })();
    },
    loadRequireContent() {
      let params = {};
      (async () => {
        let rotation = []
        const { data } = await api.get(`v2/campaign/${this.$route.params.id}/content/orientation/require/`, { needToken: true, params: params })

        // if (this.requireContent) {
        //   this.checkContent(this.requireContent, data)
        // } else {
          this.requireContent = data
        // }
      })();
    },
    loadListings() {
      let params = {};
      (async () => {
        this.isLoadingListings = true
        const { data } = await api.get(`v2/campaign/${this.$route.params.id}/selected_devices/`, { needToken: true, params: params })
        this.listings = data
        this.mappingListings()
        if (this.filter.length == 0) this.loadFilter()
        this.isLoadingListings = false
      })();
    },
    loadFilter() {
      let list = this.listings
      this.filter = [{id:0, label: `All`, value: `-`}]
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          this.filter.push({
            id: index + 1,
            label: key === `spbu` ? key.toUpperCase() : key.charAt(0).toUpperCase() + key.substr(1),
            value: key
          })
        }
      })
    },
    mappingCategory() {
      this.channels.map(channel => {
        this.allCategory.push(channel.category)
      })
    },
    mappingDate() {
      this.channels.map(channel => {
        if (channel.start){
          let start = new Date(channel.start)
          // this.startDate[channel.category] = start
          channel.start = start
        }

        if (channel.end) {
          let end = new Date(channel.end)
          // this.endDate[channel.category] = end
          channel.end = end
        }
      })
    },
    mappingListings (category=null) {
      let list = this.listings
      this.lists = []
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          if (category) {
            if (category == key) {
              this.lists.push({
                title: key.charAt(0).toUpperCase() + key.substr(1),
                items: list[key]
              })
            }
          } else {
            this.lists.push({
              title: key.charAt(0).toUpperCase() + key.substr(1),
              items: list[key]
            })
          }
        }
      })
    },
    chooseMedia(orientation) {
      this.orientationOnModal = orientation
      this.openMediaModal()
    },
    openMediaModal() {
      this.mediaModal = true
    },
    closeMediaModal() {
      this.mediaModal = false
    },
    setMedia(item, remove=false) {
      (async () => {
        this.isLoadingListings = true
        let orientation = item.orientation.toLowerCase()
        if (orientation == 'landscape') {
          this.selectedLandscape = item
        } else if (orientation == 'portrait') {
          this.selectedPortrait = item
        } else {
          this.selectedSquare = item
        }
        let body = {
          content: item.id
        }
        if (remove) body['remove'] = true
        const { data } = await api.patch(`v2/campaign/${this.$route.params.id}/content/assign/`, body, { needToken: true })
        this.closeMediaModal()
        this.isLoadingListings = false
      })();
    },
    changeMediaTab(selected) {
      this.modalMediaTab = selected
    },
    // tooltipToggle(status) {
    //   if (status == 'active') {
    //     this.tooltipImg = '/img/icons/ic-info-active@2x.png'
    //   } else {
    //     this.tooltipImg = '/img/icons/ic-info@2x.png'
    //   }
    // }
    addmore() {
      this.$router.push({name: 'addmorecampaign', params: { id: this.$route.params.id }})
    },
    searchList() {
      var listsTemp = this.lists
      this.searchNotFound = false
      let list = this.listings
      this.lists = []
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          let arrs = list[key].filter((arr) => {
            return arr.location_name.toLowerCase().includes(this.searchBoxValue.toLowerCase())
          })
          if (arrs.length) {
            this.lists.push({
              title: arrs[0].category_display,
              items: arrs
            })
          }
        }
      })
      if (this.lists.length == 0) {
        this.searchNotFound = true
        this.lists = listsTemp
      }
    },
    closeModal() {
      this.searchBoxValue= ''
      this.isShowListings = false
    }
  },
  watch: {
    campaignName: function () {
      if (this.initial) {
        this.initial = false
      } else {
        if (this.campaignName.length <= 50) {
          this.inputError = ''
          let data = {
            campaign_name: this.campaignName
          };
          (async () => {
            const response = await api.put(`v2/campaign/${this.$route.params.id}/info/update/`,
            data, { needToken: true })
            if (response.status == 200) {
              // this.estimatePrice(category)
            }
          })();
        } else {
          this.inputError = 'Name value is too long, please do not exceed 50 characters'
        }
      }
    },
    campaignDuration: function () {
      if (this.initialDuration) {
        this.initialDuration = false
      } else {
        let data = {
          duration: this.campaignDuration
        };
        (async () => {
          this.isLoadTotalPrice = true
          this.allCategory.forEach((name, index) => {
            this.isLoadEstimatePrice[name] = true
          })
          const response = await api.put(`v2/campaign/${this.$route.params.id}/info/update/`,
          data, { needToken: true })
          if (response.status == 200) {
            this.estimatePrice('all')
          }
          this.isLoadTotalPrice = true
          this.allCategory.forEach((name, index) => {
            this.isLoadEstimatePrice[name] = true
          })
        })();
      }
    },
    selectedFilter: function () {
      if (this.selectedFilter != '-'){
        this.mappingListings(this.selectedFilter)
      } else {
        this.mappingListings()
      }
    },
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(() => {
        if (this.selectedFilter != '-'){
          this.mappingListings(this.selectedFilter)
        } else {
          this.mappingListings()
        }
        this.searchList()
      });
    }, 500),
  },
  computed: {
    totalPrice() {
      let total = 0
      this.channels.map(channel => {
        total += channel.total_price
      })
      return total
    },
    totalListings() {
      let total = 0
      this.channels.map(channel => {
        total += channel.items
      })
      return total
    },
    tomorrow() {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.input input {
  height: 62px;
}

@include breakpoint (md) {
  .input{
    input {
      height: 46px;
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .textArea {
    textArea {
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .selectDropdown {
    .select {
      input {
        min-height: unset !important;
        height: 46px;
        font-size: 12px;

        &:valid ~ .select__title {
          font-size: 10px;
        }
      }
      // .select__icon {
      //   top: 15px;
      // }
    }
  }
}
</style>